<div fxHide.sm fxHide.xs fxLayout="column" fxShow.lg fxShow.md fxShow.xl>
  <div class="menu-bar" fxLayout="row" [style.background]="getBackground()" fxLayoutGap="1rem">
    <div (click)="goToNextPage('/')" fxFlex="5">
      <div fxLayout="row">
        <img alt="Viindhya Group Logo" class="logo" ngSrc="/images/logo.png" height="100" width="150" priority />
      </div>
    </div>
    <div class="menu" fxFlex="83" fxLayoutAlign="center" fxLayoutGap="1rem">
      <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="1rem">
        <button (click)="goToNextPage('/')" *ngIf="!isInternalUser()" [class.active]="isActive('/')"
          mat-button>Home</button>
        <button (click)="goToNextPage('/products')" [class.active]="isActive('/products')" mat-button>Products</button>

        <button (click)="goToNextPage('/deliveries')" *ngIf="isLoggedIn() && canDeliveryView()"
          [class.active]="isActive('/deliveries')" mat-button>
          <span>Deliveries</span>
        </button>
        <button (click)="goToNextPage('/contact-us')" *ngIf="!isInternalUser()" [class.active]="isActive('/contact-us')"
          mat-button>Contact Us</button>
        <span *ngIf="isLoggedIn() && isInternalUser()" class="env-label"><mat-icon *ngIf="getEnvironmentLabel()" class="local-icon-color">{{ getEnvironmentIcon() }}</mat-icon>{{ getEnvironmentLabel() }}</span>
      </div>
    </div>

    <div fxFlex="10">
      <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="1rem">
        <button (click)="goToNextPage('/login')" *ngIf="!isLoggedIn()" class="login-button" mat-button>
          Log In/Sign Up
        </button>
        <ng-container *ngIf="isLoggedIn()">
          <button [matMenuTriggerFor]="accountMenu" #accountMenuTrigger="matMenuTrigger" class="login-button" mat-button
            (mouseenter)="onTriggerEnter(accountMenuTrigger)" (mouseleave)="onWrapperLeave(accountMenuTrigger)"
            (menuOpened)="isAccountMenuOpen = true" (menuClosed)="isAccountMenuOpen = false">
            <span>My Account</span>
          </button>
          <mat-menu #accountMenu="matMenu" class="my-account-menu" hasBackdrop="false">
            <div (mouseenter)="onMenuPanelEnter(accountMenuTrigger)"
              (mouseleave)="onMenuPanelLeave(accountMenuTrigger)">
              <div class="user-info">
                <span *ngIf="isInternalUser()">
                  <div>{{ mobileNumber }}</div>
                  <div style="font-size: 0.8rem; font-weight: 600; color: #666; line-height: 1.2; margin-top: 2px;">{{
                    email }}</div>
                  <div class="roles-container">
                    <ul class="roles-list">
                      <li *ngFor="let role of getRole">{{ formatRole(role) }}</li>
                    </ul>
                  </div>
                </span>
                <span *ngIf="!isInternalUser() && isAgent()">(Ref ID: {{ userData.customerRefNumber }})
                  <div class="roles-container">
                    <ul class="roles-list">
                      <li *ngFor="let role of getRole">{{ formatRole(role) }}</li>
                    </ul>
                  </div>
                </span>
                <span *ngIf="!isInternalUser()">{{ userData?.firstName }}</span>
              </div>
              <button (click)="goToNextPage(this.userId+'/personal-information')" *ngIf="!isInternalUser()"
                class="my-account-menu" mat-menu-item><span>🧑 Profile</span></button>
              <button (click)="logout()" class="my-account-menu" mat-menu-item><span>↩️ Logout</span></button>
            </div>
          </mat-menu>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<mat-toolbar color="primary" fxHide.lg fxHide.md fxHide.xl fxShow.sm fxShow.xs>
  <div class="mobile-toolbar-inner">
    <div class="mobile-logo" (click)="goToNextPage('/')">
      <img alt="Viindhya Group Logo" src="/images/logo.png" width="64" height="43" loading="lazy">
    </div>
    <div class="mobile-actions">
      <span *ngIf="isLoggedIn() && isInternalUser()" class="env-label"><mat-icon *ngIf="getEnvironmentLabel()" class="local-icon-color">{{ getEnvironmentIcon() }}</mat-icon>{{ getEnvironmentLabel() }}</span>
      <button *ngIf="isDirectSaleEnabled && !isInternalUser()" (click)="goToNextPage('/shop/cart')" mat-icon-button
        [matBadge]="cartCount" [matBadgeHidden]="cartCount === 0" matBadgeColor="warn" matBadgeOverlap="true"
        matTooltip="Shopping Cart" aria-label="Shopping Cart">
        <mat-icon>shopping_cart</mat-icon>
      </button>
      <button *ngIf="isLoggedIn()" #userMenuTrigger="matMenuTrigger" (click)="toggleUserMenu(userMenuTrigger)"
        [matMenuTriggerFor]="mobileUserMenu" mat-icon-button aria-label="User Menu">
        <mat-icon>account_circle</mat-icon>
      </button>
      <button *ngIf="!isLoggedIn()" [matMenuTriggerFor]="mobileAccountMenu" mat-icon-button aria-label="Account Menu">
        <mat-icon>person</mat-icon>
      </button>
      <button (click)="toggleMenu()" class="menu-button" mat-icon-button aria-label="Toggle Menu">
        <mat-icon>{{ isMenuOpen ? 'close' : 'menu' }}</mat-icon>
      </button>
    </div>
  </div>

  <div class="nav-overlay" [class.show]="isMenuOpen" (click)="closeMenu()"></div>
  <nav [class.show]="isMenuOpen">
    <div class="nav-header">
      <span class="nav-title">Menu</span>
      <button mat-icon-button (click)="closeMenu()" class="close-btn" aria-label="Close Menu">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="nav-links">
      <a (click)="closeMenu()" *ngIf="!isInternalUser()" [class.active]="isActive('/')" routerLink="/">
        <mat-icon>home</mat-icon><span>Home</span>
      </a>

      <a (click)="closeMenu()" *ngIf="isInternalUser() && canMarketingUser()" [class.active]="isActive('/enquiries')"
        routerLink="/enquiries">
        <mat-icon>contact_mail</mat-icon><span>Enquiries</span>
      </a>

      <a (click)="closeMenu()" [class.active]="isActive('/products')" routerLink="/products">
        <mat-icon>category</mat-icon><span>Products</span>
      </a>

      <div class="mobile-dropdown" *ngIf="isLoggedIn() && isSchemeUser()">
        <div class="mobile-dropdown-trigger" (click)="toggleMobileDropdown('userProducts')"
          [class.active]="isActive('/user-products') || isActive('/emiPayments')">
          <div class="trigger-left">
            <mat-icon>inventory_2</mat-icon><span>User Products</span>
          </div>
          <mat-icon class="chevron">{{ mobileDropdowns['userProducts'] ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <div class="mobile-dropdown-items" [class.open]="mobileDropdowns['userProducts']">
          <a (click)="closeMenu()" [class.active]="isActive('/user-products')" routerLink="/user-products">
            <mat-icon>inventory_2</mat-icon><span>{{ isInternalUser() ? 'User Products' : 'User Products' }}</span>
          </a>
          <a (click)="closeMenu()" [class.active]="isActive('/emiPayments')" routerLink="/emiPayments"
            *ngIf="isSchemeEmiUser()">
            <mat-icon>payments</mat-icon><span>EMI Payments</span>
          </a>
          <a (click)="closeMenu()" [class.active]="isActive('/dspPayments')" routerLink="/dspPayments"
             *ngIf="isSchemeEmiUser()">
            <mat-icon>payments</mat-icon><span>DSP Payments</span>
          </a>
        </div>
      </div>

      <div class="mobile-dropdown" *ngIf="isDirectSaleEnabled && isLoggedIn()">
        <div class="mobile-dropdown-trigger" (click)="toggleMobileDropdown('directSale')"
          [class.active]="isActive('/shop') || isActive('/shop-orders')">
          <div class="trigger-left">
            <mat-icon>storefront</mat-icon><span>Shop</span>
          </div>
          <mat-icon class="chevron">{{ mobileDropdowns['directSale'] ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <div class="mobile-dropdown-items" [class.open]="mobileDropdowns['directSale']">
          <a (click)="closeMenu()" [class.active]="isActive('/shop')" routerLink="/shop">
            <mat-icon>shopping_cart</mat-icon><span>Buy Bars & Coins</span>
          </a>
          <a (click)="closeMenu()" [class.active]="isActive('/shop-orders')" *ngIf="isSchemeUser()" routerLink="/shop-orders">
            <mat-icon>receipt_long</mat-icon><span>Orders</span>
          </a>
        </div>
      </div>
      <a (click)="closeMenu()" *ngIf="isDirectSaleEnabled && !isLoggedIn()" [class.active]="isActive('/shop')"
        routerLink="/shop">
        <mat-icon>storefront</mat-icon><span>Shop</span>
      </a>

      <div class="mobile-dropdown" *ngIf="isLoggedIn() && isInternalUser() && canUserView()">
        <div class="mobile-dropdown-trigger" (click)="toggleMobileDropdown('userMgmt')"
          [class.active]="isActive('/users') || isActive('/agents')">
          <div class="trigger-left">
            <mat-icon>manage_accounts</mat-icon><span>Users</span>
          </div>
          <mat-icon class="chevron">{{ mobileDropdowns['userMgmt'] ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <div class="mobile-dropdown-items" [class.open]="mobileDropdowns['userMgmt']">
          <a (click)="closeMenu()" [class.active]="isActive('/users')" routerLink="/users">
            <mat-icon>group</mat-icon><span>Users List</span>
          </a>
          <a (click)="closeMenu()" *ngIf="isInvestmentManager" [class.active]="isActive('/agents')"
            routerLink="/agents">
            <mat-icon>support_agent</mat-icon><span>Agents List</span>
          </a>
        </div>
      </div>

      <a [routerLink]="['/funds', walletData?.id, 'transactions']" (click)="closeMenu()"
        *ngIf="isLoggedIn() && !isInternalUser() && canTransactionView()" [class.active]="isActive('/funds')">
        <mat-icon>account_balance_wallet</mat-icon>
        <span [matBadge]="transactionCount" [matBadgeHidden]="!transactionCount || transactionCount === 0"
          matBadgeColor="warn" matBadgeOverlap="false">Transactions</span>
      </a>

      <a (click)="closeMenu()" *ngIf="canDeliveryView()" [class.active]="isActive('/deliveries')"
        routerLink="/deliveries">
        <mat-icon>local_shipping</mat-icon><span>Deliveries</span>
      </a>

      <a (click)="closeMenu()" *ngIf="isLoggedIn() && isInternalUser() && canTransactionView()"
        [class.active]="isActive('/transactions')" routerLink="/transactions">
        <mat-icon>receipt</mat-icon>
        <span [matBadge]="transactionCount" [matBadgeHidden]="!transactionCount || transactionCount === 0"
          matBadgeColor="warn" matBadgeOverlap="false">Transactions</span>
      </a>

      <a (click)="closeMenu()" *ngIf="isLoggedIn() && !isInternalUser() && isAgent()"
        [class.active]="isActive('/agents/' + userId)" [routerLink]="'/agents/' + userId">
        <mat-icon>account_balance_wallet</mat-icon><span>Earnings</span>
      </a>

      <a (click)="closeMenu()" *ngIf="isLoggedIn() && isInternalUser() && isAccountManager()"
        [class.active]="isActive('/reports')" routerLink="/reports">
        <mat-icon>bar_chart</mat-icon><span>Reports</span>
      </a>

      <div class="mobile-dropdown" *ngIf="isInternalUser() && isMetalAssetUser()">
        <div class="mobile-dropdown-trigger" (click)="toggleMobileDropdown('coins')"
          [class.active]="isActive('/metal-assets') || isActive('/req-metal-assets')">
          <div class="trigger-left">
            <mat-icon>toll</mat-icon><span>Coins and Bars</span>
          </div>
          <mat-icon class="chevron">{{ mobileDropdowns['coins'] ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <div class="mobile-dropdown-items" [class.open]="mobileDropdowns['coins']">
          <a (click)="closeMenu()" [class.active]="isActive('/metal-assets')" routerLink="/metal-assets">
            <mat-icon>toll</mat-icon><span>Coins & Bars</span>
          </a>
          <a (click)="closeMenu()" *ngIf="isMetalAssetManager()" [class.active]="isActive('/req-metal-assets')"
            routerLink="/req-metal-assets">
            <mat-icon>pending_actions</mat-icon><span>Req. Coins & Bars</span>
          </a>
        </div>
      </div>

<!--      <a (click)="closeMenu()"-->
<!--         [class.active]="isActive('/blogs')" routerLink="/blogs">-->
<!--        <mat-icon>bar_chart</mat-icon><span>Blog</span>-->
<!--      </a>-->
      <div class="mobile-dropdown"
        *ngIf="isInternalUser() && (isInvestmentManager || isInventoryManager || isMetalDesignManager || isDirectSaleLiveRatesManager || isSchemeTransferManager)">
        <div class="mobile-dropdown-trigger" (click)="toggleMobileDropdown('config')"
          [class.active]="isActive('/investments') || isActive('/incentive-programs') || isActive('/shop-inventory') || isActive('/metal-design-config') || isActive('/coupons') || isActive('/shop-live-rates-config') || isActive('/scheme-transfer') || isActive('/scheme-frequency-transfer')">
          <div class="trigger-left">
            <mat-icon>settings_suggest</mat-icon><span>Configuration Setup</span>
          </div>
          <mat-icon class="chevron">{{ mobileDropdowns['config'] ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <div class="mobile-dropdown-items" [class.open]="mobileDropdowns['config']">
          <a (click)="closeMenu()" *ngIf="isInvestmentManager" [class.active]="isActive('/purchase-configurations')"
            routerLink="/purchase-configurations">
            <mat-icon>settings_suggest</mat-icon><span>Configuration</span>
          </a>
          <a (click)="closeMenu()" *ngIf="isInvestmentManager" [class.active]="isActive('/upcoming-deliveries')"
             routerLink="/upcoming-deliveries">
            <mat-icon>local_shipping</mat-icon><span>Estimated Deliveries</span>
          </a>
          <a (click)="closeMenu()" *ngIf="isInvestmentManager" [class.active]="isActive('/incentive-programs')"
             routerLink="/incentive-programs">
            <mat-icon>loyalty</mat-icon><span>Incentive Program</span>
          </a>
          <a (click)="closeMenu()" *ngIf="isDirectSaleEnabled && isInventoryManager"
            [class.active]="isActive('/shop-inventory')" routerLink="/shop-inventory">
            <mat-icon>inventory</mat-icon><span>Direct Sale Inventory</span>
          </a>
          <a (click)="closeMenu()" *ngIf="isDirectSaleEnabled && isMetalDesignManager"
            [class.active]="isActive('/metal-design-config')" routerLink="/metal-design-config">
            <mat-icon>category</mat-icon><span>Metal Design Config</span>
          </a>
          <a (click)="closeMenu()" *ngIf="isDirectSaleEnabled && isInventoryManager"
            [class.active]="isActive('/coupons')" routerLink="/coupons">
            <mat-icon>confirmation_number</mat-icon><span>Coupons</span>
          </a>
          <a (click)="closeMenu()" *ngIf="isDirectSaleEnabled && isDirectSaleLiveRatesManager"
            [class.active]="isActive('/shop-live-rates-config')" routerLink="/shop-live-rates-config">
            <mat-icon>trending_up</mat-icon><span>DS Live Rates Config</span>
          </a>
          <a (click)="closeMenu()" *ngIf="isSchemeTransferManager" [class.active]="isActive('/scheme-transfer')"
            routerLink="/scheme-transfer">
            <mat-icon>swap_horiz</mat-icon><span>Scheme Transfer</span>
          </a>
          <a (click)="closeMenu()" *ngIf="isSchemeTransferManager" [class.active]="isActive('/scheme-frequency-transfer')"
            routerLink="/scheme-frequency-transfer">
            <mat-icon>tune</mat-icon><span>Scheme Frequency Transfer</span>
          </a>
        </div>
      </div>

<!--      <a (click)="closeMenu()" *ngIf="!isLoggedIn()" [class.active]="isActive('/about-us')" routerLink="/about-us">-->
<!--        <mat-icon>info</mat-icon><span>About Us</span>-->
<!--      </a>-->

      <a (click)="closeMenu()" *ngIf="!isInternalUser()" [class.active]="isActive('/contact-us')"
        routerLink="/contact-us">
        <mat-icon>contact_support</mat-icon><span>Contact Us</span>
      </a>

      <div class="nav-footer">
        <a (click)="goToNextPage('/login'); closeMenu()" *ngIf="!isLoggedIn()" class="nav-login-link">
          <mat-icon>login</mat-icon><span>Log In / Sign Up</span>
        </a>
        <a (click)="logout()" *ngIf="isLoggedIn()" class="nav-logout-enhanced">
          <mat-icon>logout</mat-icon><span>Logout</span>
        </a>
      </div>
    </div>
  </nav>

  <mat-menu #mobileAccountMenu="matMenu" class="custom-account-menu">
    <div class="menu-header">
      <h3>Welcome to Viindhya Group</h3>
      <p>Access your account and manage your products here.</p>
    </div>
    <div class="menu-buttons">
      <button color="primary" mat-button routerLink="/login">LOGIN</button>
      <button color="accent" mat-button routerLink="/customer-signup">SIGN-UP</button>
    </div>
  </mat-menu>

  <mat-menu #mobileUserMenu="matMenu">
    <div class="user-info">
      <span *ngIf="isInternalUser()">
        {{ mobileNumber }}
        <div class="roles-container">
          <ul class="roles-list">
            <li *ngFor="let role of userData.roles">{{ formatRole(role) }}</li>
          </ul>
        </div>
      </span>
      <span *ngIf="!isInternalUser() && isAgent()">
        {{ userData?.firstName || 'Agent' }} (Ref ID: {{ userData.customerRefNumber || '' }})
        <div class="roles-container">
          <ul class="roles-list">
            <li *ngFor="let role of userData.roles">{{ formatRole(role) }}</li>
          </ul>
        </div>
      </span>
      <span *ngIf="!isInternalUser() && !isAgent()">{{ userData?.firstName || 'User' }}</span>
    </div>
    <button *ngIf="!isInternalUser() && isUserVerified" [routerLink]="['/users/'+userId+'/funds']" mat-menu-item>
      <mat-icon>account_balance_wallet</mat-icon><span>My Funds</span>
    </button>
    <button *ngIf="!isInternalUser() && isAgent()" [routerLink]="['/agents/'+userId]" mat-menu-item>
      <mat-icon>wallet</mat-icon><span>Earnings</span>
    </button>
    <button *ngIf="!isInternalUser()" mat-menu-item routerLink="/user-products">
      <mat-icon>view_list</mat-icon><span>My Products</span>
    </button>
    <button *ngIf="!isInternalUser()" mat-menu-item routerLink="/shop-orders">
      <mat-icon>receipt_long</mat-icon><span>My Orders</span>
    </button>
    <button *ngIf="!isInternalUser() && isUserVerified" (click)="getTokens()" mat-menu-item>
      <mat-icon>star</mat-icon><span>My Tokens</span>
    </button>
    <button *ngIf="!isInternalUser()" [routerLink]="[userId+'/personal-information']" mat-menu-item>
      <mat-icon>person</mat-icon><span>Profile</span>
    </button>
    <button (click)="logout()" *ngIf="isLoggedIn()" mat-menu-item>
      <mat-icon>logout</mat-icon><span>Logout</span>
    </button>
  </mat-menu>
</mat-toolbar>
